module.exports = __webpack_public_path__ + "img/ic_watermark@3x.d2d36cc1.png";